(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6603,2317,2769,1664,5063,8010,107],{

/***/ 24100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/defaultpic.119a8e64.webp","height":269,"width":264,"blurDataURL":"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoIAAgAAkA4JaQAA3AA/vgQAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 82827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ToastContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ToastContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    open: function open(span) {}
});


/***/ }),

/***/ 54213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ToastContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82827);


var useToast = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ToastContext__WEBPACK_IMPORTED_MODULE_1__/* .ToastContext */ .u);
};


/***/ }),

/***/ 76603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shared_ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(26628);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(26298);
// EXTERNAL MODULE: ./store/cart/index.js + 3 modules
var cart = __webpack_require__(28286);
// EXTERNAL MODULE: ./node_modules/svg-react-loader/lib/loader.js!./svg/check.svg
var check = __webpack_require__(95842);
var check_default = /*#__PURE__*/__webpack_require__.n(check);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./images/defaultpic.webp
var defaultpic = __webpack_require__(24100);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(54213);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/shared/ProductCard/ProductCard.module.scss
var ProductCard_module = __webpack_require__(6554);
var ProductCard_module_default = /*#__PURE__*/__webpack_require__.n(ProductCard_module);
;// CONCATENATED MODULE: ./components/shared/ProductCard/helpers.ts


var containerClasses = function(layout) {
    return classnames_default()((ProductCard_module_default())["product-card"], layout === "grid-sm" && (ProductCard_module_default())["product-card--layout--grid product-card--size--sm"], layout === "grid-nl" && (ProductCard_module_default())["product-card--layout--grid product-card--size--nl"], layout === "grid-lg" && (ProductCard_module_default())["product-card--layout--grid product-card--size--lg"], layout === "list" && (ProductCard_module_default())["product-card--layout--list"], layout === "horizontal" && (ProductCard_module_default())["product-card--layout--horizontal"]);
};

;// CONCATENATED MODULE: ./components/shared/ProductCard/ProductCardImage.tsx






var ProductCardImage = function(param) {
    var product = param.product, router = param.router, openUpCrossProd = param.openUpCrossProd, addToast = param.addToast, tablet = param.tablet;
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: (0,utils/* rightUrl */.Ab)(utils/* url.product */.HQ.product(product), router),
        prefetch: false,
        className: (ProductCard_module_default())["product-image__body"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ProductCard_module_default())["product-image__body"], " ").concat((ProductCard_module_default())["product-image__default-fms"])
            })
        })
    });
};
/* harmony default export */ var ProductCard_ProductCardImage = (ProductCardImage);

;// CONCATENATED MODULE: ./components/shared/ProductCard/CrossButton.tsx








var CrossButton = function(param) {
    var run = param.run, loading = param.loading, product = param.product, openUpCrossProd = param.openUpCrossProd, isProductInStock = param.isProductInStock, temp = param.temp, crossProd = param.crossProd, addToast = param.addToast, toastAdd = param.toastAdd, tablet = param.tablet, load = param.load;
    var dispatch = (0,es/* useDispatch */.I0)();
    var backorders = (0,es/* useSelector */.v9)(function(state) {
        return state.general.Backorders;
    });
    return isProductInStock(product) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: function(e) {
            e.preventDefault();
            run();
            temp && dispatch((0,general/* setTempData */.LH)([
                product
            ]));
            dispatch((0,general/* setCrossValid */.TV)(false));
            crossProd && openUpCrossProd(product);
            toastAdd && addToast && addToast(product);
        },
        disabled: !backorders && !isProductInStock(product),
        className: classnames_default()("\n                btn btn-primary ".concat((ProductCard_module_default())["product-card__addToCart".concat(tablet ? "-tablet" : "")], " ").concat(tablet ? (ProductCard_module_default())["show-for-tablet"] : (ProductCard_module_default())["hide-for-tablet"], "\n                 "), {
            "btn-loading": !load ? loading : false
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "add_to_cart",
            defaultMessage: "Add to cart"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(product.product_flat[0].url_key),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()("\n                btn btn-primary ".concat((ProductCard_module_default())["product-card__addToCart".concat(tablet ? "-tablet" : "")], " ").concat(tablet ? (ProductCard_module_default())["show-for-tablet"] : (ProductCard_module_default())["hide-for-tablet"], "\n                 "), {
                    "btn-loading": !load ? loading : false
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "add_to_cart",
                    defaultMessage: "Add to cart"
                })
            })
        })
    });
};
/* harmony default export */ var ProductCard_CrossButton = (CrossButton);

;// CONCATENATED MODULE: ./components/shared/ProductCard/AddToCart.tsx








var AddToCart = function(param) {
    var product = param.product, prefetch = param.prefetch, tablet = param.tablet, route = param.route;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: tablet ? (0,utils/* rightUrl */.Ab)(utils/* url.product */.HQ.product(product), route ? router : null) : utils/* url.product */.HQ.product(product),
        prefetch: prefetch,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: classnames_default()("\n                btn btn-primary ".concat((ProductCard_module_default())["product-card__addToCart".concat(tablet ? "-tablet" : "")], " ").concat(tablet ? (ProductCard_module_default())["show-for-tablet"] : (ProductCard_module_default())["hide-for-tablet"], "\n                 ")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "add_to_cart",
                    defaultMessage: "Add to cart"
                })
            })
        })
    });
};
/* harmony default export */ var ProductCard_AddToCart = (AddToCart);

;// CONCATENATED MODULE: ./components/shared/ProductCard/ProductCardInfo.tsx





var ProductCardInfo = function(param) {
    var product = param.product;
    var ref;
    var isFullArray = (product === null || product === void 0 ? void 0 : (ref = product.product_flat) === null || ref === void 0 ? void 0 : ref.length) > 0;
    var product_flat = (product !== null && product !== void 0 ? product : {}).product_flat;
    var ref1;
    var ref2 = (ref1 = product_flat === null || product_flat === void 0 ? void 0 : product_flat[0]) !== null && ref1 !== void 0 ? ref1 : {}, name = ref2.name, short_description = ref2.short_description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProductCard_module_default())["product-card__info"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductCard_module_default())["product-card__name"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    prefetch: false,
                    href: utils/* url.product */.HQ.product(product),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: isFullArray && name || ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductCard_module_default())["product-card-description"],
                children: [
                    isFullArray && short_description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: short_description.replace(/<\/?[^>]+>/gi, "")
                        }
                    }) : "",
                    " "
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductCard_ProductCardInfo = (ProductCardInfo);

// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/shared/ProductCard.tsx






















// const ProductCardImage = dynamic(() => import("./ProductCard/ProductCardImage"))
// const CrossButton = dynamic(() => import("./ProductCard/CrossButton"))
// const AddToCart = dynamic(() => import("./ProductCard/AddToCart"))
// const AuthList = dynamic(() => import("./ProductCard/AuthList"))
// const ProductCardInfo = dynamic(() => import("./ProductCard/ProductCardInfo"))
var AsyncAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9381).then(__webpack_require__.bind(__webpack_require__, 89381));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89381)
            ];
        }
    }
});
var ProductCard = function(props) {
    var ref;
    var _customer = props.customer, customer = _customer === void 0 ? false : _customer, product = props.product, layout = props.layout, dbName = props.dbName;
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.locale.code;
    });
    var rate = (0,es/* useSelector */.v9)(function(state) {
        return state.rate.exchange_rate;
    });
    var currency = (0,es/* useSelector */.v9)(function(state) {
        return state.rate.current.code;
    });
    var selectedData = (0,es/* useSelector */.v9)(function(state) {
        return state.locale.code;
    });
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var backorders = (0,es/* useSelector */.v9)(function(state) {
        return state.general.Backorders;
    });
    var router = (0,next_router.useRouter)();
    var toast = (0,useToast/* useToast */.p)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var product_flat = (product !== null && product !== void 0 ? product : {}).product_flat;
    var ref1;
    var ref2 = (ref1 = product_flat === null || product_flat === void 0 ? void 0 : product_flat[0]) !== null && ref1 !== void 0 ? ref1 : {}, name = ref2.name, has_up_sell = ref2.has_up_sell, has_cross_sell = ref2.has_cross_sell;
    var isFullArray = (product === null || product === void 0 ? void 0 : (ref = product.product_flat) === null || ref === void 0 ? void 0 : ref.length) > 0;
    var addCart = isFullArray && has_up_sell == 0 && has_cross_sell == 0;
    var onlyCross = isFullArray && has_up_sell == 0 && has_cross_sell == 1;
    var ref3 = (0,react.useState)(false), isMobile = ref3[0], setIsMobile = ref3[1];
    var ref4 = (0,react.useState)(false), isTablet = ref4[0], setIsTablet = ref4[1];
    var windowSize = (0,es/* useSelector */.v9)(function(state) {
        return state.general.windowSize;
    });
    var diffProductImage = product && product.product_images.length > 0 ? "".concat(dbName, "/storage/large/").concat(product === null || product === void 0 ? void 0 : product.product_images[0].path) : "".concat(dbName).concat(defaultpic/* default.src */.Z.src);
    (0,react.useEffect)(function() {
        if (!windowSize) dispatch((0,general/* setWindowSize */.QC)(window.innerWidth));
        setIsMobile(windowSize <= 768);
        setIsTablet(windowSize < 1024);
    }, [
        windowSize
    ]);
    var addToast = function() {
        toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "d-flex chek-fms",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((check_default()), {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "added_to_cart_toast",
                    defaultMessage: 'Product "'.concat(name, '" added to cart')
                })
            ]
        }));
    };
    var openUpCrossProd = function(product) {
        var hasUpSell = has_up_sell == 1;
        var hasCrossSell = has_cross_sell == 1;
        var page = true;
        if (!hasUpSell && hasCrossSell) {
            dispatch((0,cart/* getUpOrCrossProd */.xM)(product.id, "crossSell", locale, currency, rate.rate, page));
            dispatch((0,general/* setCrossValid */.TV)(true));
            dispatch((0,general/* setPopupName */.Sq)("crossSell"));
        }
        if (hasUpSell) {
            dispatch((0,general/* setPopupName */.Sq)("upsell"));
            dispatch((0,cart/* getUpOrCrossProd */.xM)(product.id, "upSell", locale, currency, rate.rate, page));
        }
    };
    var isProductInStock = function(product) {
        var qty = product === null || product === void 0 ? void 0 : product.product_inventories[0].qty;
        return Number(qty) > 0 || Number(qty) === 0 && backorders;
    };
    var asyncAction = function(toastAdd, temp, crossProd, dispatching, tablet, load) {
        var action = function() {
            if (!dispatching) {
                return dispatch((0,cart/* cartAddItem */.rg)(product, [], 1, cartToken, customer, selectedData, null, "homePage"));
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAction, {
            action: action,
            render: function(param) {
                var run = param.run, loading = param.loading;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_CrossButton, {
                    run: run,
                    loading: loading,
                    product: product,
                    openUpCrossProd: openUpCrossProd,
                    isProductInStock: isProductInStock,
                    toastAdd: toastAdd,
                    temp: temp,
                    crossProd: crossProd,
                    tablet: tablet,
                    addToast: addToast,
                    load: load
                });
            }
        });
    };
    var handlerProductType = function(tablet) {
        var actionParams;
        switch(product === null || product === void 0 ? void 0 : product.type){
            case "configurable":
            case "bundle":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_AddToCart, {
                    prefetch: false,
                    product: product,
                    tablet: !!tablet,
                    route: true
                });
            default:
                if (addCart) {
                    actionParams = tablet ? [
                        true,
                        false,
                        false,
                        false,
                        true
                    ] : [
                        true
                    ];
                } else if (onlyCross) {
                    actionParams = tablet ? [
                        true,
                        true,
                        true,
                        false,
                        true
                    ] : [
                        false,
                        true,
                        true,
                        false,
                        false
                    ];
                } else {
                    actionParams = tablet ? [
                        true,
                        true,
                        true,
                        false,
                        true
                    ] : [
                        false,
                        true,
                        true,
                        true,
                        false,
                        true
                    ];
                }
                break;
        }
        return asyncAction.apply(void 0, (0,_to_consumable_array/* default */.Z)(actionParams));
    };
    if (!product) {
        return null;
    }
    var productImage = product.product_images ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductCard_module_default())["product-card__image"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: (0,utils/* rightUrl */.Ab)(utils/* url.product */.HQ.product(product), router),
            prefetch: false,
            className: "".concat(isTablet ? (ProductCard_module_default())["product-card__image"] : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((ProductCard_module_default())["product-image__body"], " ").concat((ProductCard_module_default())["product-image__body-fms"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: (0,helper/* domainUrl */.HJ)(diffProductImage),
                        alt: "product cart image",
                        placeholder: "blur",
                        layout: "fill",
                        blurDataURL: "/zega/blur1.webp"
                    })
                })
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCardImage, {
        product: product,
        router: router,
        openUpCrossProd: openUpCrossProd,
        addToast: addToast
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: containerClasses(layout),
            children: [
                productImage,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCardInfo, {
                    product: product
                })
            ]
        })
    });
};
/* harmony default export */ var shared_ProductCard = (ProductCard);


/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)["default"]);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 6554:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item_overlay":"ProductCard_item_overlay__kXnso","product-card__symbol":"ProductCard_product-card__symbol__nvu4K","product-card":"ProductCard_product-card__Rhvkc","product-card__quickview":"ProductCard_product-card__quickview__q_yf5","product-card__quickview--preload":"ProductCard_product-card__quickview--preload__SQ_VB","img_btn_wrapper":"ProductCard_img_btn_wrapper__lmbRO","product-image__body":"ProductCard_product-image__body__aRu4h","product-card__image":"ProductCard_product-card__image__4mF1I","product-image__default-fms":"ProductCard_product-image__default-fms__4gQxG","preloader-animation":"ProductCard_preloader-animation__PP04m","product-card__info":"ProductCard_product-card__info__fiAG0","product-card__name":"ProductCard_product-card__name__H8bK6","product-card-description":"ProductCard_product-card-description__pxEGd","product-card__availability":"ProductCard_product-card__availability__2QumV","product-card__availability-mobile":"ProductCard_product-card__availability-mobile__GMhFv","product-card__rating":"ProductCard_product-card__rating__xlGdg","product-card__rating-legend":"ProductCard_product-card__rating-legend__TG2ZD","product-card__buttons":"ProductCard_product-card__buttons__IJuHU","product-card__addToCart--list":"ProductCard_product-card__addToCart--list__sZJPg","product-card__features-list":"ProductCard_product-card__features-list__C8j5W","product-card__badges-list":"ProductCard_product-card__badges-list__moYTl","product-card__badge":"ProductCard_product-card__badge__Jykut","product-card__badge--sale":"ProductCard_product-card__badge--sale__joPOv","product-card__badge--new":"ProductCard_product-card__badge--new__z7In6","product-card__badge--hot":"ProductCard_product-card__badge--hot__NCNRP","product-card--layout--horizontal":"ProductCard_product-card--layout--horizontal__VuAa2","product-card__description":"ProductCard_product-card__description__aTVmo","product-card--layout--grid":"ProductCard_product-card--layout--grid___RLSz","product-card--size--sm":"ProductCard_product-card--size--sm___RTyS","btn":"ProductCard_btn__B58lx","btn-svg-icon":"ProductCard_btn-svg-icon__6SS5K","product-card--size--nl":"ProductCard_product-card--size--nl__yE_YB","product-card--size--lg":"ProductCard_product-card--size--lg__tQ56K","product-card__actions":"ProductCard_product-card__actions__126Gu","product-card__prices":"ProductCard_product-card__prices__ItqLb","product-card--layout--list":"ProductCard_product-card--layout--list__imzdT","product-card__old-price":"ProductCard_product-card__old-price__iWPx5","product-card__addToCart":"ProductCard_product-card__addToCart__xWL_R","product-card__wishlist":"ProductCard_product-card__wishlist__A_zGj","product-card__compare":"ProductCard_product-card__compare__7h5_s","product-image__img":"ProductCard_product-image__img__j_aKP","owl-carousel":"ProductCard_owl-carousel__P2vNX","owl-item":"ProductCard_owl-item__84lAk","product-card__addToCart-tablet":"ProductCard_product-card__addToCart-tablet__ZAQY_","hide-for-tablet":"ProductCard_hide-for-tablet__tJEc2","show-for-tablet":"ProductCard_show-for-tablet__5X_Gl"};

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ })

}]);